import { useGetMe } from 'api-hooks/auth/query';
import { ProductSalesModel } from 'api-hooks/product/sales';
import { generateId } from 'common/utils/string';
import React from 'react';

import {
  ProductSaleDetailFormType,
  ProductSaleFormType,
} from '../components/form-type';

export interface UseGetDefaultValuesProps {
  productSale?: ProductSalesModel;
  defaultValues?: ProductSaleFormType;
}

export function onAddNewProduct(): ProductSaleDetailFormType {
  return {
    customId: generateId(),
    description: '',
    price: undefined,
    productVariantId: undefined,
    qty: undefined,
    stock: undefined,
  } as unknown as ProductSaleDetailFormType;
}

export function duplicate(value: ProductSaleFormType): ProductSaleFormType {
  const transactionAt = new Date();

  return {
    ...value,
    refId: undefined,
    transactionAt,
    tempTransactionAt: transactionAt,
    productSale: undefined,
    productSales: value.productSales.map((ps) => {
      return {
        ...ps,
        id: undefined,
      };
    }),
  };
}
export default function useGetDefaultValues(
  props: UseGetDefaultValuesProps,
): ProductSaleFormType {
  const { productSale } = props;
  const { data: employeeData } = useGetMe();
  const employeeHook = employeeData?.data;

  const defaultValues = React.useMemo<ProductSaleFormType>(() => {
    if (props.defaultValues) {
      return duplicate(props.defaultValues);
    }
    const transactionAt = productSale?.transactionAt ?? new Date();
    const customer = productSale?.customer;

    const productSales: ProductSaleDetailFormType[] =
      productSale?.productSales?.map((ps) => {
        const productVariant = ps.productVariant;
        return {
          customId: generateId(),
          description: ps.description || '',
          price: ps.price || 0,
          productVariantId: {
            id: productVariant.id,
            label: ps.completeName,
          },
          qty: ps.qty,
          stock: productVariant.stock,
        };
      }) ?? [onAddNewProduct()];

    return {
      address: productSale?.customer.address || '',
      adminId: productSale?.admin.id ?? employeeHook?.id ?? '',
      code: productSale?.code || '',
      customerBillingId: productSale?.customerBillingAddress?.id ?? '',
      customerBillingOptions: [],
      customerId: customer?.id ?? '',
      customerStatus: customer?.status ?? '',
      hasDueReceivable: customer?.hasDueReceivables ?? false,
      remainingTransactionQuota: null,
      isExceedingQuota: false,
      description: productSale?.description || '',
      discount: productSale?.discount ?? 0,
      needApproval: false,
      number: productSale?.invoiceNumber ?? '',
      operatorId: productSale?.operator?.id ?? '',
      otherCost: productSale?.otherCost ?? 0,
      phone: customer?.phone ?? '',
      refId: productSale?.refId,
      parentRefId: productSale?.parentSale?.refId,
      salesmanId: productSale?.salesman?.id ?? '',
      total: productSale?.total ?? 0,
      transactionAt,
      tempTransactionAt: transactionAt,
      productSales,
      productSale,
    };
  }, [employeeHook?.id, productSale, props.defaultValues]);

  return defaultValues;
}
